export const heroSlides = [
  {
    id: 1,
    kicker: "本周精选",
    title: "把笑声调成慢速的一天",
    description:
      "羽毛、毛毯和一点点意外感。精选轻挠视频合集，陪你度过一个完全不用赶时间的下午。",
    cta: "去看看这些视频",
    to: "/videos/detail/1",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20illustration%20of%20a%20cozy%20sunlit%20living%20room%20with%20a%20cream%20sofa%2C%20soft%20blanket%2C%20white%20feathers%20floating%20in%20golden%20light%20and%20long%20warm%20shadows%2C%20playful%20gentle%20mood%2C%20minimal%20editorial%20style%20with%20rich%20honey%20and%20beige%20tones&width=1600&height=900&seq=home-hero-01&orientation=landscape",
  },
  {
    id: 2,
    kicker: "爆笑推荐",
    title: "猜错一次，就要被挠十秒",
    description:
      "蒙眼猜道具挑战上线。两个人从自信满满到笑到说不出话，只用了三分钟。",
    cta: "播放这期挑战",
    to: "/videos/detail/2",
    image:
      "https://readdy.ai/api/search-image?query=Playful%20warm%20wide%20illustration%20of%20a%20bright%20cozy%20room%20with%20a%20blindfold%2C%20feathers%20and%20small%20mystery%20boxes%20on%20a%20cream%20table%2C%20golden%20evening%20lamplight%2C%20joyful%20game%20show%20atmosphere%2C%20minimal%20flat%20illustration%20in%20honey%20tones&width=1600&height=900&seq=home-hero-02&orientation=landscape",
  },
  {
    id: 3,
    kicker: "社区热议",
    title: "先说好边界，才能笑得更尽兴",
    description:
      "社区里被收藏最多的一篇讨论：三条简单的约定，让轻松的互动变得更安心。",
    cta: "进入社区看看",
    to: "/community/detail/3",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20calm%20wide%20illustration%20of%20two%20friends%20sitting%20on%20a%20cream%20rug%20with%20tea%20and%20a%20notebook%2C%20warm%20afternoon%20sunlight%20through%20large%20windows%2C%20quiet%20friendly%20conversation%20mood%2C%20minimal%20editorial%20flat%20style%20with%20beige%20palette&width=1600&height=900&seq=home-hero-03&orientation=landscape",
  },
];

export const categoryEntries = [
  {
    key: "videos",
    to: "/videos",
    title: "挠痒视频",
    subtitle: "轻挠、爆笑、互动挑战",
    description: "九个精心挑选的短片，从三分钟到十五分钟，随时挑一个放松一下。",
    icon: "ri-play-circle-line",
    accent: "primary",
  },
  {
    key: "articles",
    to: "/articles",
    title: "趣味文章",
    subtitle: "科普、笔记与生活提案",
    description: "把好奇的问题写清楚，用最轻松的方式聊聊触觉和情绪。",
    icon: "ri-article-line",
    accent: "accent",
  },
  {
    key: "community",
    to: "/community",
    title: "社区交流",
    subtitle: "分享、提问与温和讨论",
    description: "真实体验、入门疑问、道具心得，都能在这里找到同频的人。",
    icon: "ri-chat-smile-2-line",
    accent: "secondary",
  },
];

export const teamMembers = [
  {
    name: "阿栗",
    role: "社区管理员",
    bio: "负责社区氛围与内容审核，最常回复的一句话是「舒服最重要」。",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20warm%20portrait%20illustration%20of%20a%20young%20asian%20woman%20with%20short%20hair%20and%20a%20soft%20smile%2C%20cream%20background%2C%20minimal%20flat%20editorial%20style%20in%20beige%20and%20honey%20tones&width=400&height=400&seq=team-01&orientation=squarish",
  },
  {
    name: "小满",
    role: "内容编辑",
    bio: "写科普也写生活提案，喜欢把复杂的事讲得像聊天一样。",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20portrait%20illustration%20of%20a%20young%20asian%20man%20with%20round%20glasses%20and%20a%20gentle%20expression%2C%20soft%20cream%20background%2C%20minimal%20flat%20editorial%20style%20in%20beige%20and%20warm%20yellow&width=400&height=400&seq=team-02&orientation=squarish",
  },
  {
    name: "老周",
    role: "视频制作",
    bio: "负责拍摄和剪辑，坚信「节奏慢一点，画面就舒服一点」。",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20portrait%20illustration%20of%20a%20middle%20aged%20asian%20man%20with%20a%20short%20beard%20and%20a%20kind%20smile%2C%20warm%20cream%20background%2C%20minimal%20flat%20editorial%20style%20in%20muted%20terracotta%20and%20beige&width=400&height=400&seq=team-03&orientation=squarish",
  },
  {
    name: "小鹿",
    role: "视觉设计",
    bio: "画所有你看到的插图，喜欢黄油色和一点点纸张的颗粒感。",
    avatar:
      "https://readdy.ai/api/search-image?query=Soft%20portrait%20illustration%20of%20a%20young%20asian%20woman%20with%20long%20wavy%20hair%20and%20a%20calm%20smile%2C%20cream%20background%2C%20minimal%20flat%20editorial%20style%20in%20beige%20and%20soft%20golden%20tones&width=400&height=400&seq=team-04&orientation=squarish",
  },
];